import React from 'react';

import ContainerPage from '../../components/ContainerPage';
import { CoverageSelector } from './components/CoverageSelector';
import { UnitSelector } from './components/UnitSelector';

import { ContainerBody, Subtext, WrapperInfo, WrapperInfo1 } from './styles';
import { CoverageProps, ProductItemProps } from '../../models/Product';
import HeadTitle from '../../components/HeadTitle';
import { Unit } from '../../components/ServiceItem';
import { HorizontalLine } from '../../components/HorizontalLine';
import { typeLocationSchedule } from '../../models/Schedule';
import { Button } from '../../components';

export type ServiceTypeTemplateProps = {
  headTitle?: string;
  scheduleProduct: ProductItemProps;
  unitsOpenToSchedule: Unit[];
  unavailableUnits: Unit[];
  unitsOnDemand: Unit[];
  unitDates: Record<string, string[]>;
  coverageSelected: CoverageProps;
  selectedUnit?: Unit;
  disableSubmitButton?: boolean;
  handleContinue: () => void;
  handleSelectedUnit: (un: Unit) => void;
  handleUnitOnDemand?: (un: Unit) => void;
  handleSelectCoverage: (cov: CoverageProps) => void;
  goBack?: () => void;
};

export const ServiceTypeTemplate = ({
  headTitle,
  scheduleProduct,
  unitsOpenToSchedule,
  unavailableUnits,
  unitsOnDemand,
  unitDates,
  coverageSelected,
  selectedUnit,
  handleSelectCoverage,
  handleSelectedUnit,
  handleUnitOnDemand,
  handleContinue,
  disableSubmitButton,
  goBack
}: ServiceTypeTemplateProps) => {
  return (
    <ContainerPage
      childrenFooter={<Button onClick={handleContinue} disabled={disableSubmitButton} title="Continuar" />}
    >
      <ContainerBody>
        <>
          <HeadTitle title={headTitle ? headTitle : 'Escolha o tipo de atendimento'} goBack={goBack} />
          <WrapperInfo1>
            <Subtext>Tipo de atendimento</Subtext>
          </WrapperInfo1>
          <CoverageSelector
            selectedCoverage={coverageSelected}
            coverages={scheduleProduct?.coverages}
            handleSelectCoverage={handleSelectCoverage}
            productName={scheduleProduct?.name}
          />
        </>

        {coverageSelected.care_type !== typeLocationSchedule.TELEMEDICINE && (
          <>
            <HorizontalLine />
            {unitsOpenToSchedule.length > 0 ? (
              <WrapperInfo>
                <Subtext>Unidades de atendimento</Subtext>
              </WrapperInfo>
            ) : null}
          </>
        )}

        {coverageSelected?.care_type && (
          <>
            <UnitSelector
              scheduleUnits={unitsOpenToSchedule}
              selectedUnit={selectedUnit}
              onLocationSelected={unit => handleSelectedUnit(unit)}
              unitDates={unitDates}
            />
            <UnitSelector
              scheduleUnits={unitsOnDemand}
              selectedUnit={selectedUnit}
              onLocationSelected={unit => handleUnitOnDemand?.(unit)}
              unitDates={unitDates}
            />
            <UnitSelector
              scheduleUnits={unavailableUnits}
              selectedUnit={selectedUnit}
              onLocationSelected={() => {}}
              unitDates={unitDates}
            />
          </>
        )}
      </ContainerBody>
    </ContainerPage>
  );
};
